module.exports = __webpack_public_path__ + "img/toggle-switch.82a85186.svg";